import React, { useState } from "react";
import { Collapse } from "@mui/material";
import { MDBBtn } from "mdb-react-ui-kit";
import { connect } from "react-redux";
import Spinner from "./Spinner";
import axios from "axios";
import { motion } from "framer-motion";
import t from "../utilities/transitions";

const RemoveFile = ({
  file,
  callback,
  centered,
  className,
  mobileView,
  shorten,
  smallButtons,
}) => {
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [working, setWorking] = useState(false);

  const confirm = () => {
    setCollapseOpen(false);
    setWorking(true);
    axios
      .post(process.env.REACT_APP_LAMBDA_SUPPORT + "/delete-file-permanent", {
        file,
      })
      .then(() => {
        if (callback) callback();
        setWorking(false);
      })
      .catch((err) => {
        setWorking(false);
        console.log(err);
        alert("An error occurred. Please try again later");
      });
  };

  if (mobileView)
    return (
      <>
        {collapseOpen ? (
          <motion.section
            transition={t.transition}
            initial={t.fade_out}
            animate={t.normalize}
            exit={t.fade_out}
            className={className}
          >
            <p className="text-center m-0">Are you sure?</p>
            <div className="w-100 d-flex">
              <MDBBtn
                className="w-50 text-primary"
                color="link"
                rippleColor="primary"
                onClick={confirm}
                type="button"
                size={smallButtons ? "sm" : ""}
              >
                Yes
              </MDBBtn>
              <MDBBtn
                className="w-50 text-primary"
                color="link"
                rippleColor="primary"
                onClick={() => setCollapseOpen(false)}
                type="button"
                size={smallButtons ? "sm" : ""}
              >
                No
              </MDBBtn>
            </div>
          </motion.section>
        ) : (
          <motion.div
            transition={t.transition}
            initial={t.fade_out}
            animate={t.normalize}
            exit={t.fade_out}
            className={className}
          >
            <MDBBtn
              onClick={() => setCollapseOpen(!collapseOpen)}
              disabled={working}
              className="bg-orange modal-buttons-mobile d-block rounded-0 w-100"
              type="button"
              size={smallButtons ? "sm" : ""}
            >
              {working ? (
                <>
                  <Spinner className="me-2" size="sm" />
                  Deleting
                </>
              ) : (
                <>
                  {collapseOpen ? (
                    "ARE YOU SURE?"
                  ) : (
                    <>
                      <i className="fas fa-fire me-2" />
                      {shorten ? "" : "PERMANENTLY "}DELETE
                    </>
                  )}
                </>
              )}
            </MDBBtn>
          </motion.div>
        )}
      </>
    );

  return (
    <div
      className={`d-flex flex-column justify-content-start ${
        centered ? "mx-auto" : ""
      } ${className}`}
    >
      <MDBBtn
        onClick={() => setCollapseOpen(!collapseOpen)}
        disabled={working}
        className="bg-orange"
        type="button"
        size={smallButtons ? "sm" : ""}
      >
        {working ? (
          <>
            <Spinner className="me-2" size="sm" />
            Deleting
          </>
        ) : (
          <>
            {collapseOpen ? (
              "ARE YOU SURE?"
            ) : (
              <>
                <i className="fas fa-fire me-2" />
                {shorten ? "" : "PERMANENTLY "}DELETE
              </>
            )}
          </>
        )}
      </MDBBtn>
      <Collapse in={collapseOpen}>
        <MDBBtn
          disabled={working}
          color="link"
          rippleColor="primary"
          className={`d-block ${centered ? "mx-auto" : ""}`}
          onClick={() => setCollapseOpen(false)}
          type="button"
          size={smallButtons ? "sm" : ""}
        >
          No
        </MDBBtn>
        <MDBBtn
          disabled={working}
          color="link"
          rippleColor="primary"
          onClick={confirm}
          className={`d-block ${centered ? "mx-auto" : ""}`}
          type="button"
          size={smallButtons ? "sm" : ""}
        >
          Yes
        </MDBBtn>
      </Collapse>
    </div>
  );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {})(RemoveFile);
